import {styled} from '@core-ui/react-stitch';

const ProductGridDivision = styled.div(({isBRRedesignEnabled}) => ({
  maxWidth: '100%',
  'flexGrow': '1',
  '*':{
    boxSizing: 'border-box',
  },
  paddingRight: !isBRRedesignEnabled && '0.5rem',
  '@media (min-width: 1024px)':{
    width: '48rem',
  },
  '@media (min-width: 1280px)':{
    width: '1024px',
  },
}));

export default ProductGridDivision;
